var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHouseFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#8DBBE5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1049 21.8476V19.8031C14.1049 19.2831 14.5288 18.8605 15.0541 18.8571H16.9781C17.5059 18.8571 17.9338 19.2806 17.9338 19.8031V19.8031V21.8539C17.9336 22.2955 18.2896 22.6563 18.7354 22.6667H20.0181C21.2968 22.6667 22.3334 21.6405 22.3334 20.3746V20.3746V14.5586C22.3266 14.0605 22.0904 13.5929 21.6921 13.2887L17.3052 9.7902C16.5367 9.18104 15.4442 9.18104 14.6757 9.7902L10.3081 13.295C9.90825 13.598 9.67167 14.0664 9.66675 14.5649V20.3746C9.66675 21.6405 10.7033 22.6667 11.982 22.6667H13.2647C13.7217 22.6667 14.0921 22.3 14.0921 21.8476V21.8476",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHouseFilled);
export default __webpack_public_path__ + "static/media/iconHouseFilled.d6366370525700fd26fedafc1f2af55b.svg";
export { ForwardRef as ReactComponent };